import {
    STATE_CHANGE,
    UPDATE_INPUT,
    initialInputState
} from '@/store/actions/autocomplete';

const initialState = {
    focusId: null,
    isOpen: false,
    isHover: false,
    inputs: { [null]: { ...initialInputState } }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STATE_CHANGE: {
            const { changes } = action.data;
            const { focusId } = changes;
            return {
                ...state,
                ...changes,
                inputs: {
                    ...state.inputs,
                    [focusId]: {
                        ...state.inputs[focusId],
                        selectedIndex: -1
                    }
                }
            };
        }

        case UPDATE_INPUT: {
            const { id, data } = action.data;
            return {
                ...state,
                inputs: {
                    ...state.inputs,
                    [id]: {
                        ...initialInputState,
                        ...state.inputs[id],
                        ...data
                    }
                }
            };
        }

        default: {
            return state;
        }
    }
};
